import React from 'react';
import FieldTypesEnum from '../../Enums/FieldTypesEnum';
import dateTimeHelper from '../../Helpers/datetimeHelper';
import moneyHelper from '../../Helpers/moneyHelper';
import RoleService from '../../Services/roleService';
import InputTypesEnum from '../../Enums/InputTypesEnum';
import DataTableRowMenu from './DataTableRowMenu';
import columnVisibilityHelper from '../../Helpers/columnVisibilityHelper';

export default function DataTableBody(props) {
  const getCellLabel = (field) => {
    if (!field || field.type === FieldTypesEnum.ActionButton) return undefined;
    const rawLabel = typeof field.label === 'function' ? field.label() : field.label;
    if (rawLabel === undefined || rawLabel === null || rawLabel === '') return undefined;
    // JSX labels (e.g. a select-all checkbox header) would serialize into the
    // data-label attribute as "[object Object]" — only text can be a card label.
    if (typeof rawLabel !== 'string' && typeof rawLabel !== 'number') return undefined;
    return rawLabel;
  };

  const generateContentCell = (data, field, item) => {
    if (
      (!data || data === field.label || data.toString().trim() === '') &&
      (field.data in item || typeof field.data === 'function')
    ) {
      return '';
    }
    return (
      <div
        className='DataTableBodyText'
        style={field.headerPosition === 'header-text-right' ? { textAlign: 'end' } : {}}
      >
        {data}
      </div>
    );
  };

  const generateContentForDataFieldWithDetails = (item, data) => {
    const idValue = item[props.nameOfTheIdField];
    return (
      <span
        className='secondarylink'
        onClick={() => props.ClickOnDataFieldWithDetails(idValue)}
        style={{ cursor: 'pointer' }}
      >
        {data}
      </span>
    );
  };

  const generateContentForText2Field = (field) => {
    return (
      <div
        className={'DataTableBodyTextFlex'}
        style={field.headerPosition === 'header-text-right' ? { textAlign: 'end' } : {}}
      >
        <div
          className={`${
            field.fieldClass === undefined || field.fieldClass === '' ? 'Figma-input-group' : field.fieldClass
          }`}
        >
          {typeof props.renderInputFieldFunction === 'function'
            ? props.renderInputFieldFunction(
                field.data,
                '',
                '',
                field.type,
                null,
                props.Lineindex,
                '',
                '',
                '',
                field.headerPosition === 'header-text-right' ? 'inputFigma inputFigmaForward' : 'inputFigma',
                field.fieldType
              )
            : ''}
        </div>
      </div>
    );
  };

  const generateContentForInputField = (field) => {
    return (
      <div
        className={`${
          field.fieldClass === undefined || field.fieldClass === '' ? 'Figma-input-group' : field.fieldClass
        }`}
      >
        {' '}
        {props.renderInputFieldFunction(
          field.data,
          '',
          '',
          field.type,
          null,
          props.Lineindex,
          null,
          field.selectValues
        )}
      </div>
    );
  };

  const generateContent = (item, field) => {
    if (field.type === FieldTypesEnum.EmptySpace) {
      return generateContentCell('', field, item);
    }

    if (
      [InputTypesEnum.Text2, InputTypesEnum.Number2, InputTypesEnum.NumberWithTwoDecimalPlaces2].includes(field.type)
    ) {
      return generateContentForText2Field(field);
    }

    if (field.type === FieldTypesEnum.JustLabel) {
      return generateContentCell(field.label, field, item);
    }

    const data = typeof field.data === 'function' ? field.data(item) : item[field.data];
    if (field.type === FieldTypesEnum.ActionButton) {
      return data;
    }

    if (!props.complex) {
      return data;
    }

    if (typeof field.type === 'function') {
      field.type = field.type(item);
    }

    if (field.type === undefined) field.type = FieldTypesEnum.PureDataField;

    if (props.type.MoneyFields !== undefined && props.type.MoneyFields.includes(field.data)) {
      return generateContentCell(moneyHelper.toMoneyFormat(data, item[props.type.Currency()]), field, item);
    }

    if (field.type === InputTypesEnum.TextReadOnly) {
      return generateContentCell(data, field, item);
    }

    if (data === '' && field.label !== '' && props.renderInputFieldFunction === undefined) {
      return generateContentCell(field.label, field, item);
    }

    if (field.type === FieldTypesEnum.DataFieldWithDetails) {
      return generateContentForDataFieldWithDetails(item, data);
    }

    if (props.type.BoolFields !== undefined && props.type.BoolFields.includes(field.data)) {
      return (data === true).toString();
    }

    if (props.type.DateFields !== undefined && props.type.DateFields.includes(field.data)) {
      return generateContentCell(dateTimeHelper.toYYYYsMMsDDWithIndefinite(data), field, item);
    }

    if (props.type.MoneyFieldsSecondary !== undefined && props.type.MoneyFieldsSecondary.includes(field.data)) {
      return generateContentCell(moneyHelper.toMoneyFormat(data, item[props.type.CurrencySecondary()]), field, item);
    }

    if (field.type !== undefined && props.renderInputFieldFunction !== undefined) {
      return generateContentForInputField(field);
    }

    if (field.type === null) {
      return '';
    }

    return data;
  };

  const renderTableCell = (listItem, field, key) => {
    if (props.hiddenColumns && props.hiddenColumns.has(columnVisibilityHelper.getColumnKey(field, key))) return null;

    const content = generateContent(listItem, field);
    const dataLabel = getCellLabel(field);

    if (!props.complex) {
      return (
        <td
          key={key + props.Lineindex}
          data-label={dataLabel}
          className={`${field.className}` && field.className}
        >
          {content}
        </td>
      );
    }

    if (field.rolekey && !RoleService.CheckUserPermission('datatable', field.rolekey, 'visit')) return null;

    if ('block' in field && !props.shownBlocks[field.block].value) return null;

    const bgcolor =
      props.shownBlocks &&
      props.shownBlocks[field.block] &&
      props.shownBlocks[field.block].bgcolor in props.colorDictionary
        ? props.colorDictionary[props.shownBlocks[field.block].bgcolor]
        : '';

    if (field.type === FieldTypesEnum.ActionButton)
      return (
        <td
          key={key + props.Lineindex}
          data-label={dataLabel}
          style={{ backgroundColor: bgcolor }}
          className='tdButtonHolder ctr'
        >
          <DataTableRowMenu>{content}</DataTableRowMenu>
        </td>
      );

    return (
      <td
        key={key + props.Lineindex}
        data-label={dataLabel}
        style={{ backgroundColor: bgcolor }}
        className={'defaultTdStyle'}
      >
        <div className={`Tablehiddenoverflow ${field.className ? field.className : ''}`}>
          <div className='DataTableBodyText'>{content}</div>
        </div>
      </td>
    );
  };

  return (
    <tr
      key={`tr${props.Lineindex}`}
      style={{ visibility: props.DataTableType === 'Header' ? 'collapse' : undefined }}
      className={props.listItem.IsMarkedRed ? 'RedDataTableRow' : 'DataTableRow'}
    >
      {props.type.FieldsToShowInDataTable(props.listItem).map((field, index) => {
        if (props.ModalFeature === true) {
          if (field.type !== FieldTypesEnum.ActionButton && field.type !== FieldTypesEnum.DataFieldWithDetails) {
            return renderTableCell(props.listItem, field, index);
          }
        } else if (field.type !== FieldTypesEnum.Navigation) {
          return renderTableCell(props.listItem, field, index);
        }
        return null;
      })}
    </tr>
  );
}
